import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'app-benchmark-timeseries',
  templateUrl: './benchmark-timeseries.component.html',
  styleUrls: ['./benchmark-timeseries.component.scss']
})
export class BenchmarkTimeseriesComponent implements OnInit {


  constructor() { }
  @ViewChild('myCanvas', { static: false }) myCanvas: ElementRef;
  public canvastime: ElementRef;
  public context: CanvasRenderingContext2D;
  public chartType: string = 'line';
  public lineChartLegend: boolean = false;
  public chartData: any[];
  public chartLabels: any[];
  public chartColors: any[];
  @Input() pageTab: any;
  @Input() guageValue: Array<any> = [];
  @Input() index: any;
  @Input() kpiScore: any;
  @Input() legend: any;
  @Input() GraphTytle:any;
  @Input() graphcheck: any;
  @Input() aggregation: any;
  @Input() units:any;
  @Input() typeGraph:boolean;
  public chartOptions: any;
  public benchLabel:Array<any>=[];
  public marginMax:number;

  // @Input() windowSizeJson:any;
  // public dataList: Array<any> = [];
  ngOnInit() { }
  ngAfterViewInit() {
    if (this.guageValue && this.guageValue.length > 0) {
      this.assignToGraph();
    }
  }

  public height: any = '';
  assignToGraph() {
    let legend_display: boolean = false;
    let _this=this;
    if (this.graphcheck == 'monitoring') {
      var hour_data = this.guageValue;//whole data
      var benchTime = [];//get date
      var benchdata = [];//get data
      var Max_number;
      let newdate: any;
      //modify code
      function changeDate(date, id) {
        var getdate = date +' ' +'(w' + id + ')';
        return getdate;
      }
      for (var i = 0; i < hour_data.length; i++) {
        if (this.aggregation == 'day') {
          newdate = new Date(hour_data[i].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
          benchdata.push(hour_data[i][hour_data[i].scoreName].toFixed(2));
          benchTime.push(newdate);
        } else if (this.aggregation == 'week') {
          newdate = new Date(hour_data[i]['testDate']).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
          benchdata.push(hour_data[i][hour_data[i].scoreName].toFixed(2));
          benchTime.push(changeDate(newdate, hour_data[i]['_id']));
        } else {
          newdate = new Date(hour_data[i].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
          let datapoint = hour_data[i].testDate.split(" ")[1];
          datapoint = datapoint.split(':');
          datapoint = datapoint[0] + ':' + '00';
          newdate = newdate + " " + datapoint;
          benchdata.push(hour_data[i][hour_data[i].scoreName].toFixed(2));
          benchTime.push(newdate);
        }
      }
      Max_number = Math.ceil(Math.max(...benchdata));
      legend_display = false;
      this.marginMax = 48;
      benchdata = [{
        data: benchdata,
        label: null,
        fill: true,
        spanGaps: true
      }];
    } else {

      if (this.aggregation == 'day') {
        var day_data = this.guageValue;//whole data
        var benchTime = [];//get dates
        var benchdata = [];//get data points
        var color = ['#044BEC', '#24CCB8', '#FFC400', '#D0F0C0', '#b19cd9','#FFC400','#f8e7a8','#F08080','#c9ede7','#FFE4B5','#FFE4E1'];
        for (let i = 0; i < day_data.length; i++) {
          let obj = day_data[i];
          let secObj = obj[obj['name']][0].all;
          benchdata.push({ label: obj['name'], borderColor: color[i], fill: true, spanGaps: true, data: [] });
          for (let j = 0; j < secObj.length; j++) {
            let newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            if (benchTime.indexOf(newdate) < 0) {
              benchTime.push(newdate);
            }
          }
        }
        
        benchTime.sort(function(a, b){
          var aa = a.split('-').reverse().join(),
              bb = b.split('-').reverse().join();
          return aa < bb ? -1 : (aa > bb ? 1 : 0);
      })
        for (let i = 0; i < day_data.length; i++) {
          let obj = day_data[i];
          let secObj = obj[obj['name']][0].all;
          for (let j = 0; j < secObj.length; j++) {
            let newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            benchdata[i]['data'][benchTime.indexOf(newdate)] = +(secObj[j][secObj[j]['scoreName']].toFixed(1));
          }
        }
        for (let i = 0; i < day_data.length; i++) {
          for (let finalInd = 0; finalInd < benchTime.length; finalInd++) {
            if (!benchdata[i]['data'][finalInd]) {
              benchdata[i]['data'][finalInd] = null;
            }
          }
        }
       
        var allMax = [];
        for (var i = 0; i < benchdata.length; i++) {
          var data = benchdata[i]['data'];
          allMax.push(Math.max(...data));
        }
        Max_number = Math.ceil(Math.max(...allMax));


      } else if (this.aggregation == 'week') {
        var week_data = this.guageValue;
        var benchTime = [];
        var benchdata = [];
        var getData = [];
        var Max_number;
        //change week format
        function changeDate(date, week_id) {
          var formatDate = date +' '+'(w' + week_id + ')'
          return formatDate;
        }

        var color = ['#044BEC', '#24CCB8', '#FFC400', '#D0F0C0', '#b19cd9'];//custom color
        for (let i = 0; i < week_data.length; i++) {
          let obj = week_data[i];
          let secObj = obj[obj['name']][0].all;
          benchdata.push({ label: obj['name'], borderColor: color[i], fill: true, spanGaps: true, data: [] });
          for (let j = 0; j < secObj.length; j++) {
            let newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            newdate = changeDate(newdate, secObj[j]._id);
            if (benchTime.indexOf(newdate) < 0) {
              benchTime.push(newdate);
            }
            if (getData.indexOf(newdate) < 0) {
              getData.push(changeDate(newdate, secObj[j]._id));
            }
          }
        }

        //sorting of dates
        // benchTime.sort(function (a: any, b: any) {
        //   console.log(a,b);
        //   return new Date(a).getTime() - new Date(b).getTime();
        // });
        // getData.sort(function (a: any, b: any) {
        //   return new Date(a).getTime() - new Date(b).getTime();
        // });
        getData.sort(function(a, b){
          var aa = a.split('-').reverse().join(),
              bb = b.split('-').reverse().join();
          return aa < bb ? -1 : (aa > bb ? 1 : 0);
      })
        benchTime.sort(function(a, b){
          var aa = a.split('-').reverse().join(),
              bb = b.split('-').reverse().join();
          return aa < bb ? -1 : (aa > bb ? 1 : 0);
      })
        for (let i = 0; i < week_data.length; i++) {
          let obj = week_data[i];
          let secObj = obj[obj['name']][0].all;
          for (let j = 0; j < secObj.length; j++) {
            var newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            newdate = changeDate(newdate, secObj[j]._id);
            benchdata[i]['data'][benchTime.indexOf(newdate)] = +(secObj[j][secObj[j]['scoreName']].toFixed(1));
          }
        }
        for (let i = 0; i < week_data.length; i++) {
          for (let finalInd = 0; finalInd < benchTime.length; finalInd++) {
            if (!benchdata[i]['data'][finalInd]) {
              benchdata[i]['data'][finalInd] = null;
            }
          }
        }

        var allMax = [];
        for (var i = 0; i < benchdata.length; i++) {
          var data = benchdata[i]['data'];
          allMax.push(Math.max(...data));
        }
        Max_number = Math.ceil(Math.max(...allMax));
      } else {
        var day_data = this.guageValue;//whole data
        var benchTime = [];//get dates
        var benchdata = [];//get data points
        var color = ['#044BEC', '#24CCB8', '#FFC400', '#D0F0C0', '#b19cd9'];

        for (let i = 0; i < day_data.length; i++) {
          let obj = day_data[i];
          let secObj = obj[obj['name']][0].all;
          benchdata.push({ label: obj['name'], borderColor: color[i], fill: true, spanGaps: true, data: [] });
          for (let j = 0; j < secObj.length; j++) {
            var newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            let datapoint = secObj[j].testDate.split(" ")[1];
            datapoint = datapoint.split(':');
            datapoint = datapoint[0] + ':' + '00';
            newdate = newdate + " " + datapoint;
            if (benchTime.indexOf(newdate) < 0) {
              benchTime.push(newdate);
            }
          }
        }
        benchTime.sort(function (a: any, b: any) {
          return new Date(a).getTime() - new Date(b).getTime()
        });
        for (let i = 0; i < day_data.length; i++) {
          let obj = day_data[i];
          let secObj = obj[obj['name']][0].all;
          for (let j = 0; j < secObj.length; j++) {
            var newdate = new Date(secObj[j].testDate).toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3');
            let datapoint = secObj[j].testDate.split(" ")[1];
            datapoint = datapoint.split(':');
            datapoint = datapoint[0] + ':' + '00';
            newdate = newdate + " " + datapoint;
            benchdata[i]['data'][benchTime.indexOf(newdate)] = +(secObj[j][secObj[j]['scoreName']].toFixed(1));
          }
        }
        for (let i = 0; i < day_data.length; i++) {
          for (let finalInd = 0; finalInd < benchTime.length; finalInd++) {
            if (!benchdata[i]['data'][finalInd]) {
              benchdata[i]['data'][finalInd] = null;
            }
          }
        }
        var allMax = [];
        for (var i = 0; i < benchdata.length; i++) {
          var data = benchdata[i]['data'];
          allMax.push(Math.max(...data));
        }
        
        Max_number = Math.ceil(Math.max(...allMax));
      }

      legend_display = true;
      this.marginMax = 14;
    }
    
      if(benchTime && benchTime.length){
        this.benchLabel=[];
        for(let i=0;i<benchTime.length;i++){
          let split = benchTime[i].split(" ")[0];
          let split1 = benchTime[i].split(" ")[1]?benchTime[i].split(" ")[1]:'';
         this.benchLabel.push([split,split1]);
        }
      }
    this.chartData = benchdata;
     
    this.chartLabels = this.benchLabel;
    this.chartColors = [{
      backgroundColor: 'rgba(124,181,236,0.1)',
      borderColor: '#7cb5ec'
    }];
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        display: legend_display
      },
      title: {
				display: true,
				position: "top",
				fontSize: 18,
				text:this.GraphTytle
		},
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          scaleLabel: {
            fontColor:"darkgray",
            display: true,
            labelString: this.aggregation ? this.aggregation : null
          },
          ticks: {
            beginAtZero: true,
            fontColor:"darkslategray",
            autoSkip: true,
            maxTicksLimit: 5,
            minTicksLimit: 5,
            minRotation:0,
          maxRotation:0,

          },
          time: {
            tooltipFormat: 'YYYY-MM-DD HH:mm',
            // displayFormats: {
            format: "YYYY-MM-DD HH:mm",

            // }
          }
        }],
        yAxes: [{
          scaleLabel: {
            fontColor:"darkgray",
            display: true,
            labelString: this.kpiScore ? this.kpiScore + '('+(this.typeGraph?'Metric':'Index')+')' : null
          },
          ticks: {
            beginAtZero: true,
            fontColor:"darkslategray",
            max: Max_number,
            min: 0,
            stepSize: Math.ceil(Max_number/5),
            userCallback: function (tick) {
              if (_this.typeGraph) {
                if(_this.units)
                return (tick).toString() +' '+(_this.units[_this.kpiScore]).toString();
              }
              return tick.toString();
            }
          },
        }],
      },
      // this.units
    }

  }
  ngDoCheck() {
    let elem:any = document.getElementsByClassName('canvastime');
    if (elem && elem.length>0) {
      for(let i=0;i<elem.length;i++){
      let divElem:any = elem[i] ? elem[i].parentElement.parentElement.parentElement.clientHeight : 340;
      this.height = divElem - this.marginMax;
      elem[i].style.height = this.height+"px";
     }
    }
  }
}
